var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"buttonContainer",staticClass:"button-container",style:(_vm.buttonContainerStyl)},[_c('div',{ref:"wdButton",staticClass:"btn-box",style:(_vm.wdButton),on:{"click":_vm.clickLink}},[_c('span',{ref:"btnText",style:(_vm.btnText)},[_vm._v(_vm._s(_vm.receiveProps.tempData.buttonContentData.buttonDes))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }